import React from 'react';
import { SectionTitle } from './SectionTitle';
import { painItems } from '../data/salesCopy';
export function PainSection() {
  return <section className="bg-brand-ivory px-4 py-8 sm:py-10" data-id="element-115" data-mp="38xetra38ohqd">
      <div className="mx-auto max-w-3xl" data-id="element-116" data-mp="2uyoxfwo8um32">
        <SectionTitle data-id="element-117" data-mp="2uxvwxdfvostd">😩 Arrêtez de repartir de zéro pour chaque cours</SectionTitle>

        <p className="mt-4 text-[13px] font-medium leading-snug text-brand-brown/85 sm:text-[15px]" data-id="element-118" data-mp="2yyfw0mk0i6i5">
          Votre temps devrait être consacré à enseigner — pas à chercher des
          postures, reconstruire des séquences et organiser des notes dispersées.
        </p>
        <p className="mt-1.5 text-[13px] font-bold leading-snug text-brand-brown sm:text-[15px]" data-id="element-119" data-mp="2baxwu5yf4655">
          YIN YOGA PRO™ rassemble les ressources pour vous.
        </p>

        <ul className="mt-3 grid grid-cols-1 gap-1.5 sm:grid-cols-2" data-id="element-120" data-mp="229hvenpkzed2">
          {painItems.map(item => <li key={item} className="rounded border border-brand-sand bg-white px-3 py-2 text-[12.5px] font-semibold leading-snug text-brand-brown sm:text-[13.5px]" data-id="element-121" data-mp="278baulofhffv">
              {item}
            </li>)}
        </ul>

        <p className="mt-3 text-[13px] font-medium leading-snug text-brand-brown/85 sm:text-[15px]" data-id="element-122" data-mp="3nni8qo0bkh3t">
          Tout est organisé pour vous permettre de choisir la structure
          pertinente, sélectionner vos postures, prévoir les adaptations et
          préparer votre séance en utilisant votre expérience professionnelle.
        </p>
        <p className="mt-3 text-center font-serif text-lg font-bold uppercase tracking-wide text-brand-sage sm:text-xl" data-id="element-123" data-mp="33xybmatlgxbm">
          Moins de préparation. Plus de structure.
        </p>
      </div>
    </section>;
}